import { Languages } from '@/common/utils/constants';
import { MembershipTypeSectionItemsInterface } from '@/widgets/BecomeAMember/components/Receipt/components/MembershipTypeSection/MembershipTypeSection.types';
import ReceiptDetailsTitleSection from '@/widgets/BecomeAMember/components/Receipt/components/common/ReceiptDetailsTitleSection/ReceiptDetailsTitleSection';
import { determineAdditionalText } from '@/widgets/BecomeAMember/components/Receipt/utils/determoneAdditionalText';
import { determineLocaleDateStringFromTodayIncreasedByTime } from '@/widgets/BecomeAMember/components/Receipt/utils/determineLocaleDate';
import { formatDate } from '@/widgets/BecomeAMember/components/Receipt/utils/formatDate';
import { formatPrice } from '@/common/utils/formatPriceForDisplay';

interface TimeBasedVoucherPeriodProps
  extends MembershipTypeSectionItemsInterface {
  lang: Languages;
}

export default function TimeBasedVoucherPeriod({
  translations,
  voucherData,
  currency,
  priceDecimalSeparator = '.',
  startDate,
  lang,
  termData,
}: TimeBasedVoucherPeriodProps) {
  const isRecurring = termData.paymentFrequencyType === 'RECURRING';
  const isCompanyFeeSplit = voucherData?.voucher_type === 'COMPANY_FEE_SPLIT';

  const timeBasedVoucherPrice = isCompanyFeeSplit
    ? (voucherData.member_amount ?? '')
    : (voucherData?.discounted_base_price ?? voucherData?.base_price ?? '');

  const oldTimeBasedVoucherPrice = isCompanyFeeSplit
    ? (voucherData.discounted_base_price ?? '')
    : (voucherData?.base_price ?? '');

  const termStartDate = formatDate(startDate, lang);

  const timeBasedVoucherEndDate =
    determineLocaleDateStringFromTodayIncreasedByTime({
      amount: Number(voucherData?.effective_period_time_based_term?.value ?? 0),
      unit: voucherData?.effective_period_time_based_term?.unit ?? '',
      lang,
      startDate: new Date(termData.defaultContractStartDate ?? ''),
    });

  const additionalTimeBasedVoucherText = isRecurring
    ? determineAdditionalText({
        startDate: termStartDate ?? '',
        endDate: timeBasedVoucherEndDate ?? '',
        termValue: String(termData.paymentFrequencyValue),
        termUnit: String(termData.paymentFrequencyUnit),
        translations,
      })
    : `${termStartDate} - ${timeBasedVoucherEndDate}`;

  const isOldTimeBasedVoucherPrice =
    Number(oldTimeBasedVoucherPrice) !== Number(timeBasedVoucherPrice);

  return (
    <ReceiptDetailsTitleSection
      title={translations['becomeamember.floatingreceipt.discountterm']}
      additionalText={additionalTimeBasedVoucherText}
      currency={currency}
      price={formatPrice(timeBasedVoucherPrice, priceDecimalSeparator)}
      oldPrice={
        isOldTimeBasedVoucherPrice
          ? formatPrice(oldTimeBasedVoucherPrice, priceDecimalSeparator)
          : ''
      }
    />
  );
}
